// Generated by ReScript, PLEASE EDIT WITH CARE


function displayGender(gender) {
  switch (gender) {
    case /* FEMALE */0 :
        return "หญิง";
    case /* MALE */1 :
        return "ชาย";
    case /* OTHER */2 :
        return "อื่นๆ";
    
  }
}

var err_text = {
  firstname: "พยัญชนะภาษาไทยหรืออังกฤษเท่านั้น",
  lastname: "พยัญชนะภาษาไทยหรืออังกฤษเท่านั้น",
  mobile: "กรอกเบอร์โทรศัพท์มือถือ 10 หลัก (เช่น 0811234567)",
  email: "กรอกอีเมลให้ถูกต้อง (เช่น roza@gmail.com)",
  postcode: "กรอกรหัสไปรษณีย์ให้ถูกต้อง (เช่น 10600)"
};

var placeholder_text = {
  must_input: "กรุณากรอกข้อมูล",
  option_input: "กรุณากรอกข้อมูล (ถ้ามี)",
  must_choose: "กรุณากรอกเลือก"
};

var arr_occupation = [
  "พ่อบ้านแม่บ้าน",
  "พ่อค้าแม่ค้า",
  "อาชีพอิสระ",
  "เจ้าของกิจการ",
  "พนักงานบริษัท/ข้าราชการ/รัฐวิสาหกิจ",
  "นักเรียน/นักศึกษา",
  "อื่นๆ"
];

export {
  displayGender ,
  err_text ,
  placeholder_text ,
  arr_occupation ,
  
}
/* No side effect */
